<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a> 
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">{{ operacion }}Administrador</h1></div>
    </div>

    <div class="row filters fade-in tag-row" *ngIf="id">
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'perfil'}" (click)="selectFilter('perfil')" id="infoPerfil">Perfil</div>
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'detalle'}" (click)="selectFilter('detalle')" id="infoDetalle">Detalle</div>
    </div>

    <div class="row mt-2 mb-2" *ngIf="id">
        <div class="col">
            <small class="text-muted">
                Creado: {{ d_fecha_creacion | date:'dd/MM/yyyy HH:mm' }} hs
                <ng-container *ngIf="d_fecha_modificacion">
                    &nbsp;·&nbsp;Última modificación: {{ d_fecha_modificacion | date:'dd/MM/yyyy HH:mm' }} hs
                    <ng-container *ngIf="x_modificado_por">&nbsp;por {{ x_modificado_por }}</ng-container>
                </ng-container>
            </small>
        </div>
    </div>

    <!-- Sections -->
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'perfil'}">
        <div class="row-cols-12 m-2">
            <div class="text-p p-3">
                <div class="col file fileuploadphoto text-center">
                    @if (!preview_img_avatar()) {
                        <img src="./assets/img/user-init.png" style="width:80px" class="text-end rounded-circle business-profile">
                    } @else {
                        <img [src]="preview_img_avatar()" style="width:80px" class="text-end rounded-circle business-profile imagen-preview" (click)="openModal()">
                    }
                    <input type="file" #profileimage class="form-control input-image" id="profileimage" style="display: none;" (change)="capturarFileImgAvatar()">
                    <label class="changeimage" (click)="capturarFileImgAvatar()">cambiar</label>
                </div>
            </div>    
        </div>
        <!-- Modal Previw IMG PERFIL :: INICIO -->
        <div class="modal fade" id="modalPreviewImg" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalPreviewImgLabel">Foto Perfil</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <img [src]="preview_img_avatar_large()" class="img-fluid">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Modal Previw IMG PERFIL :: FIN -->
        <div class="row-cols-12 m-2 mt-0">
            <div class="row p-3 mb-0 align-items-center">
                <div class="mb-3 mt-0 text-start ">
                    <form (ngSubmit)="saveUsuario()" [formGroup]="moreUsuario">
                        <div class="mb-4 mt-2 text-start ">
                            <label for="perfil" class="form-label">Perfil</label>
                            <select class="form-control" name="perfil" formControlName="perfil">
                                @for (perfil of perfiles; track perfil.id) {
                                    <option [ngValue]="perfil.id">{{ perfil.x_descripcion }}</option>
                                }
                            </select>
                            @if (moreUsuario.controls['perfil'].invalid && (moreUsuario.controls['perfil'].dirty || moreUsuario.controls['perfil'].touched) && moreUsuario.controls['perfil'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El perfil es requerido</small></div>
                            }
                        </div>
                        <div class="mb-4 mt-2 text-start ">
                            <label for="email" class="form-label"><b>Email</b></label>
                            <input type="email" class="form-control" id="email" formControlName="email" placeholder="Ingrese un email" [readOnly]="id!==''">
                            @if (moreUsuario.controls['email'].invalid && (moreUsuario.controls['email'].dirty || moreUsuario.controls['email'].touched) && moreUsuario.controls['email'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El email es requerido</small></div>
                            }
                        </div>
                        <div class="mb-4 mt-2 text-start ">
                            <label for="password" class="form-label"><b>Password</b></label>
                            <div class="password-field">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" id="password" formControlName="password" placeholder="Ingrese un password">
                                <i  class="bi seePassword"
                                    [ngClass]="{
                                    'bi-eye-slash': !fieldTextType,
                                    'bi-eye': fieldTextType
                                    }"
                                    (click)="toggleFieldTextType()"
                                ></i>
                            </div>
                            @if (moreUsuario.controls['password'].invalid && (moreUsuario.controls['password'].dirty || moreUsuario.controls['password'].touched) && moreUsuario.controls['password'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El password es requerido</small></div>
                            }
                        </div>
                        <div class="mb-4 mt-2 text-start ">
                            <label for="repetir_password" class="form-label"><b>Repetir Password</b></label>
                            <div class="password-field">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" id="repetir_password" formControlName="repetir_password" placeholder="Repita el password">
                                <i  class="bi seePassword"
                                    [ngClass]="{
                                    'bi-eye-slash': !fieldTextType,
                                    'bi-eye': fieldTextType
                                    }"
                                    (click)="toggleFieldTextType()"
                                ></i>
                            </div>
                            @if (moreUsuario.controls['repetir_password'].invalid && (moreUsuario.controls['repetir_password'].dirty || moreUsuario.controls['repetir_password'].touched) && moreUsuario.controls['repetir_password'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El repetir password es requerido</small></div>
                            }
                        </div>
                        @if (error()) {
                            <div class="alert alert-danger mt-2" role="alert">
                                <small>{{ error() }}</small>
                            </div>
                        }
                        <div class="d-grid mt-5 mb-2">
                            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Administrador'}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'detalle'}">
        <div class="row-cols-12 m-2 mt-0">
            <div class="row p-3 mb-0 align-items-center">
                <div class="mb-3 mt-0 text-start ">
                    <form (ngSubmit)="saveUsuarioDetalle()" [formGroup]="myAccountIdentidad">
                        <div class="row mt-4">
                            <div class="col">
                                <label for="nombre" class="form-label">Nombre</label>
                                <input type="text" class="form-control" formControlName="nombre">
                            </div>
                            <div class="col">
                                <label for="apellido" class="form-label">Apellido</label>
                                <input type="text" class="form-control" formControlName="apellido">
                            </div>
                        </div>
                        @if (myAccountIdentidad.controls['nombre'].invalid && (myAccountIdentidad.controls['nombre'].dirty || myAccountIdentidad.controls['nombre'].touched) && myAccountIdentidad.controls['nombre'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">El Nombre es requerido</small></div>
                        }
                        @if (myAccountIdentidad.controls['apellido'].invalid && (myAccountIdentidad.controls['apellido'].dirty || myAccountIdentidad.controls['apellido'].touched) && myAccountIdentidad.controls['apellido'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">El Apellido es requerido</small></div>
                        }
                        <div class="row mt-4">
                            <div class="col">
                                <label for="telefono" class="form-label">Teléfono</label>
                                <input type="text" inputmode="numeric" class="form-control" formControlName="telefono" (input)="soloNumeros('telefono', $event)">
                                @if (myAccountIdentidad.controls['telefono'].invalid && (myAccountIdentidad.controls['telefono'].dirty || myAccountIdentidad.controls['telefono'].touched) && myAccountIdentidad.controls['telefono'].errors?.['required']) {
                                    <div class="alert-danger" role="alert"><small class="alert">Ingrese un Teléfono válido</small></div>
                                }
                            </div>
                            <div class="col">
                                <label for="nro_socio" class="form-label">Nro. Socio</label>
                                <div class="position-relative">
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="nro_socio"
                                        [mask]="maskSocio()"
                                        [showMaskTyped]="true"
                                        placeholder="Nro. Socio"
                                    />
                                    @if (isCheckingSocio()) {
                                        <span class="spinner-border spinner-border-sm text-secondary dni-spinner" role="status" aria-hidden="true"></span>
                                    }
                                </div>
                            </div>
                        </div>
                        @if (asociadoCardio()) {
                            <div class="row mt-4">
                                <div class="col">
                                    <label class="form-label">Contacto de Emergencia</label>
                                    <input type="text" inputmode="numeric" class="form-control" formControlName="telefono_emergencia" (input)="soloNumeros('telefono_emergencia', $event)">
                                    @if (myAccountIdentidad.controls['telefono_emergencia'].invalid && (myAccountIdentidad.controls['telefono_emergencia'].dirty || myAccountIdentidad.controls['telefono_emergencia'].touched) && myAccountIdentidad.controls['telefono_emergencia'].errors?.['required']) {
                                        <div class="alert-danger" role="alert"><small class="alert">Ingrese un Teléfono válido</small></div>
                                    }
                                </div>
                            </div>
                        }
                        <div class="row mt-4 mb-4">
                            <div class="col">
                                <label for="tipo_documento" class="form-label">Tipo</label>
                                <select class="form-control" name="tipo_documento" formControlName="tipo_documento" (change)="actualizarMascara()">
                                    @for (td of tiposDocumentos(); track td.id) {
                                        <option [ngValue]="td.id">{{ td.x_descripcion }}</option>
                                    }
                                </select>
                            </div>
                            <div class="col">
                                <label for="nro_documento" class="form-label">Documento</label>
                                <div class="position-relative">
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="nro_documento"
                                        [mask]="maskDocumento()"
                                        [showMaskTyped]="true"
                                        placeholder="DNI / CUIT / CUIL"
                                    />
                                    @if (isCheckingDni()) {
                                        <span class="spinner-border spinner-border-sm text-secondary dni-spinner" role="status" aria-hidden="true"></span>
                                    }
                                </div>
                            </div>
                        </div>
                        @if (asociadoCardio()) {
                            <div class="row m-3 pt-2 pb-2 pr-1 pl-1 align-items-center" id="tooltip-pwa">
                                <div class="col-auto"><img src="./assets/img/logo-cardio.svg" class="img-asociado"></div>
                                <div class="col" id="helpinfo">Asociado a <b>Cardio 24hs</b></div>
                            </div>
                        }
                        @if (myAccountIdentidad.controls['tipo_documento'].invalid && (myAccountIdentidad.controls['tipo_documento'].dirty || myAccountIdentidad.controls['tipo_documento'].touched) && myAccountIdentidad.controls['tipo_documento'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">El Tipo de Documento es requerido</small></div>
                        }
                        @if (myAccountIdentidad.controls['nro_documento'].invalid && (myAccountIdentidad.controls['nro_documento'].dirty || myAccountIdentidad.controls['nro_documento'].touched) && myAccountIdentidad.controls['nro_documento'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">Ingrese un Nro. de Documento válido</small></div>
                        }
                        @if (myAccountIdentidad.controls['nro_documento'].errors?.['maxlength']) {
                            <div class="alert-danger" role="alert"><small class="alert">El número de documento no puede tener más de 13 caracteres.</small></div>
                        }
                        <div class="row mt-0">
                            <div class="col">
                                <div class="credencial-wrapper">
                                    @if (preview_img_dni_frente()) {
                                        <div class="credencial-actions">
                                            <div class="credencial-action-icon" (click)="capturarFileImgDniFrente()">
                                                <i class="bi bi-pencil"></i>
                                            </div>
                                            <div class="credencial-action-icon delete-credential" (click)="eliminarImgDniFrente()">
                                                <i class="bi bi-trash"></i>
                                            </div>
                                        </div>
                                    }
                                    <div class="file fileupload m-0 p-0 rounded bg-transparent">
                                        @if (!preview_img_dni_frente()) {
                                            <div class="btn file fileupload m-0" (click)="capturarFileImgDniFrente()">
                                                <div style="background-color: transparent;">
                                                    <label>Cargar</label> DNI frente
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="imagen-preview">
                                                <img [src]="preview_img_dni_frente()" width="100px" alt="DNI frente" class="imgdni m-0 p-0 rounded" data-bs-toggle="modal" data-bs-target="#modalPreviewImgDniFrente">
                                            </div>
                                            <div class="imagen-preview-label mt-1">DNI frente</div>
                                        }
                                        <input type="file" #profileimageDniFrente class="form-control input-image" id="img_dni_frente" value="img_dni_frente" style="display: none;" (change)="capturarFileImgDniFrente()">
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="credencial-wrapper">
                                    @if (preview_img_dni_dorso()) {
                                        <div class="credencial-actions">
                                            <div class="credencial-action-icon" (click)="capturarFileImgDniDorso()">
                                                <i class="bi bi-pencil"></i>
                                            </div>
                                            <div class="credencial-action-icon delete-credential" (click)="eliminarImgDniDorso()">
                                                <i class="bi bi-trash"></i>
                                            </div>
                                        </div>
                                    }
                                    <div class="file fileupload m-0 p-0 rounded bg-transparent">
                                        @if (!preview_img_dni_dorso()) {
                                            <div class="btn file fileupload m-0" (click)="capturarFileImgDniDorso()">
                                                <div style="background-color: transparent;">
                                                    <label>Cargar</label> DNI dorso
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="imagen-preview">
                                                <img [src]="preview_img_dni_dorso()" width="100px" alt="DNI dorso" class="imgdni m-0 p-0 rounded" data-bs-toggle="modal" data-bs-target="#modalPreviewImgDniDorso">
                                            </div>
                                            <div class="imagen-preview-label mt-1">DNI dorso</div>
                                        }
                                        <input type="file" #profileimageDniDorso class="form-control input-image" id="img_dni_dorso" value="img_dni_dorso" style="display: none;" (change)="capturarFileImgDniDorso()">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal Previw IMG DNI FRENTE :: INICIO -->
                        <div class="modal fade" id="modalPreviewImgDniFrente" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgDniFrenteLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="modalPreviewImgDniFrenteLabel">DNI Frente</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                                    </div>
                                    <div class="modal-body">
                                        <img [src]="preview_img_dni_frente()" class="img-fluid">
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal Previw IMG DNI FRENTE :: FIN -->
                        <!-- Modal Previw IMG DNI DORSO :: INICIO -->
                        <div class="modal fade" id="modalPreviewImgDniDorso" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgDniDorsoLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="modalPreviewImgDniDorsoLabel">DNI Dorso</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                                    </div>
                                    <div class="modal-body">
                                        <img [src]="preview_img_dni_dorso()" class="img-fluid">
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal Previw IMG DNI DORSO :: FIN -->

                        <!-- Modal confirmar eliminar imagen -->
                        <div class="modal fade" id="modalConfirmarEliminarImagen" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content confirmar-eliminar-content">
                                    <div class="modal-body text-center pt-4 pb-2">
                                        <div class="confirmar-eliminar-icono">
                                            <i class="bi bi-trash"></i>
                                        </div>
                                        <h5 class="mt-3 mb-2">Eliminar imagen</h5>
                                        <p class="text-muted mb-0">¿Querés eliminar {{ nombreImagenAEliminar() }}? Esta acción no se puede deshacer.</p>
                                    </div>
                                    <div class="modal-footer border-0 pt-2 pb-4 justify-content-center">
                                        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>
                                        <button type="button" class="btn btn-danger rounded-pill px-4" (click)="confirmarEliminarImagen()">Eliminar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if (error()) {
                            <div class="alert alert-danger mt-2" role="alert">
                                <small>{{ error() }}</small>
                            </div>
                        }
                        <div class="d-grid mt-4 mb-3 pb-3">
                            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Administrador'}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>